import { render, staticRenderFns } from "./Item.vue?vue&type=template&id=4c5a8c3e&"
import script from "./Item.vue?vue&type=script&lang=js&"
export * from "./Item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c5a8c3e')) {
      api.createRecord('4c5a8c3e', component.options)
    } else {
      api.reload('4c5a8c3e', component.options)
    }
    module.hot.accept("./Item.vue?vue&type=template&id=4c5a8c3e&", function () {
      api.rerender('4c5a8c3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/2.0/js/modules/Audience/Export/Components/Item.vue"
export default component.exports